import React from 'react';
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import {getStore, setStore} from "trim-redux";
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../../../config/design/styles";
import SubTitle from "../../../../components/elements/SubTitle";
import axios from "axios";
import {defaultVariabls} from "../../../../../config/index";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {Translate} from "../../../../../config/Translate";

import {Link} from "react-router-dom";
import NotifSound from '../../../../../files/sounds/notif.mp3';
import clsx from "clsx";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button/Button";
import Dialog from "@material-ui/core/Dialog/Dialog";
import {updateRedux} from "../../../../../config/Security";
class ToDos extends React.Component {
    state = {
        products: null,
        gathering_orders: null,
        revisions: null,
        shops: null,
        verification_details: null,
        wallets: null,
        reviews: null,
        contacts: null,
        marketers: null,
        rejected_products: null,
        umc: null,
        loading:true,
        open:false,
    };
    componentDidMount() {
        this.loadData();
        this.interval = setInterval(() => this.loadData(), 65000); // Run loadData every 60 seconds
    }

    componentWillUnmount() {
        clearInterval(this.interval); // Clear interval when component unmounts
    }
    async componentDidUpdate(newProps){
        if(this.state.beginDate !== this.props.beginDate){
            await this.setState({
                beginDate: this.props.beginDate
            })
            await this.loadData();
        }
        if(this.state.endDate !== this.props.endDate){
            await this.setState({
                endDate: this.props.endDate
            })
            await this.loadData();
        }
    }
    async loadData(){
        let {beginDate,endDate,open} = this.state;
        if((!!beginDate && !!endDate) || (!beginDate && !endDate)){

            let loginToken = localStorage.getItem('ACT');
            if(loginToken !== null){
                let config = {
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Bearer ${loginToken}`
                    }
                };
                await axios.get(`${defaultVariabls.url}/analytics/todos`, config)
                    .then(response => {
                        let newData = {
                            products: response.data.products,
                            gathering_orders: response.data.gathering_orders,
                            revisions: response.data.revisions,
                            shops: response.data.shops,
                            verification_details: response.data.verification_details,
                            wallets: response.data.wallets,
                            reviews: response.data.reviews,
                            contacts: response.data.contacts,
                            marketers: response.data.marketers,
                            rejected_products: response.data.rejected_products,
                            umc: response.data.umc,
                        };

                        this.checkForIncrease(newData);

                        this.setState({ ...newData, loading: false });
                    }).catch(error => {
                        console.log(error.response)
                        this.setState({
                            loading:false
                        })
                    })
            }else {
                setStore({
                    isAuth : false,
                    user : null,
                    loading:false
                });
                this.setState({
                    loading:false
                })
            }
        }
    }
    checkForIncrease(newData) {
        const { products,gathering_orders, revisions, shops, verification_details, wallets, reviews, contacts,marketers,umc,rejected_products } = this.state;

        let hasIncreased =
            (products !== null && newData.products > products) ||
            (gathering_orders !== null && newData.gathering_orders > gathering_orders) ||
            (revisions !== null && newData.revisions > revisions) ||
            (shops !== null && newData.shops > shops) ||
            (verification_details !== null && newData.verification_details > verification_details) ||
            (wallets !== null && newData.wallets > wallets) ||
            (reviews !== null && newData.reviews > reviews) ||
            (umc !== null && newData.umc > umc) ||
            (rejected_products !== null && newData.rejected_products > rejected_products) ||
            (marketers !== null && newData.marketers > marketers) ||
            (contacts !== null && newData.contacts > contacts);

        if (hasIncreased) {
            updateRedux();
            this.playNotificationSound();
        }
    }

    playNotificationSound = () => {
        const audio = new Audio(NotifSound);
        let user = getStore('user');
        if(!!user.has_sound){
            audio.play().catch(error => {
                this.setState({
                    open:true
                })
            });
        }

    };
    classes = this.props.classes;
    render(){
        let {products,gathering_orders,revisions,shops,verification_details,reviews,wallets,loading,contacts,marketers,rejected_products,open} = this.state;
        return (
            <>
                <Grid container spacing={2} direction="row" alignItems="center">
                    <Grid item xs={12} sm={6} md={3} lg>
                        <Link to={'/manage/orders?status=gathering'} className="todo_link">
                            <Grid container  style={{backgroundColor: "#fff",position:"relative"}} direction="row" alignItems="center" justify="center" className={clsx(this.classes.GridAsaPaperBaby,'grid-parent')}>
                                {
                                    gathering_orders > 0 && <span className="ripple"></span>
                                }
                                <Grid item xs={11}>
                                    <SubTitle>
                                        {Translate.confirmedOrders}
                                    </SubTitle>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography style={{textAlign:"center",marginTop:10,marginBottom:15}} className={this.classes.AnalyticsResult} >{loading ? <CircularProgress size={25}/> : gathering_orders}</Typography>
                                </Grid>
                            </Grid>
                        </Link>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg>
                        <Link to={'/manage/products?status=unconfirmed'} className="todo_link">
                            <Grid container  style={{backgroundColor: "#fff",position:"relative"}} direction="row" alignItems="center" justify="center" className={clsx(this.classes.GridAsaPaperBaby,'grid-parent')}>
                                {
                                    products > 0 && <span className="ripple"></span>
                                }
                                <Grid item xs={11}>
                                    <SubTitle>
                                        {Translate.book_confirmation_requests}
                                    </SubTitle>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography style={{textAlign:"center",marginTop:10,marginBottom:15}} className={this.classes.AnalyticsResult} >{loading ? <CircularProgress size={25}/> : products}</Typography>
                                </Grid>
                            </Grid>
                        </Link>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg>
                        <Link to={'/manage/products?status=rejected'} className="todo_link">
                            <Grid container  style={{backgroundColor: "#fff",position:"relative"}} direction="row" alignItems="center" justify="center" className={clsx(this.classes.GridAsaPaperBaby,'grid-parent')}>
                                <Grid item xs={11}>
                                    <SubTitle>
                                        {Translate.rejected_products}
                                    </SubTitle>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography style={{textAlign:"center",marginTop:10,marginBottom:15}} className={this.classes.AnalyticsResult} >{loading ? <CircularProgress size={25}/> : rejected_products}</Typography>
                                </Grid>
                            </Grid>
                        </Link>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg>
                        <Link to="/manage/revisions" className="todo_link">
                            <Grid container  style={{backgroundColor: "#fff",position:"relative"}} direction="row" alignItems="center" justify="center" className={clsx(this.classes.GridAsaPaperBaby,'grid-parent')}>
                                {
                                    revisions > 0 && <span className="ripple"></span>
                                }
                                <Grid item xs={11}>
                                    <SubTitle>
                                        {Translate.book_revision_requests}
                                    </SubTitle>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography style={{textAlign:"center",marginTop:10,marginBottom:15}} className={this.classes.AnalyticsResult} >{loading ? <CircularProgress size={25}/> : revisions}</Typography>
                                </Grid>
                            </Grid>
                        </Link>

                    </Grid>

                    <Grid item xs={12} sm={6} md={3} lg>
                        <Link to={'/manage/shops?status=unconfirmed'} className="todo_link">
                            <Grid container  style={{backgroundColor: "#fff",position:"relative"}} direction="row" alignItems="center" justify="center" className={clsx(this.classes.GridAsaPaperBaby,'grid-parent')}>
                                {
                                    shops > 0 && <span className="ripple"></span>
                                }
                                <Grid item xs={11}>
                                    <SubTitle>
                                        {Translate.shop_confirmation_requests}

                                    </SubTitle>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography style={{textAlign:"center",marginTop:10,marginBottom:15}} className={this.classes.AnalyticsResult} >{loading ? <CircularProgress size={25}/> : shops}</Typography>
                                </Grid>
                            </Grid>
                        </Link>

                    </Grid>

                </Grid>
                <Grid container spacing={2} direction="row" alignItems="center">
                    <Grid item xs={12} sm={6} md={3} lg>
                        <Link to={'/manage/wallets-requests'} className="todo_link">
                            <Grid container  style={{backgroundColor: "#fff",position:"relative"}} direction="row" alignItems="center" justify="center" className={clsx(this.classes.GridAsaPaperBaby,'grid-parent')}>
                                {
                                    wallets > 0 && <span className="ripple"></span>
                                }
                                <Grid item xs={11}>
                                    <SubTitle>
                                        {Translate.wallet_confirmation_requests}
                                    </SubTitle>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography style={{textAlign:"center",marginTop:10,marginBottom:15}} className={this.classes.AnalyticsResult} >{loading ? <CircularProgress size={25}/> : wallets}</Typography>
                                </Grid>
                            </Grid>
                        </Link>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg>
                        <Link to={'/manage/verifications'} className="todo_link">
                            <Grid container  style={{backgroundColor: "#fff",position:"relative"}} direction="row" alignItems="center" justify="center" className={clsx(this.classes.GridAsaPaperBaby,'grid-parent')}>
                                {
                                    verification_details > 0 && <span className="ripple"></span>
                                }
                                <Grid item xs={11}>
                                    <SubTitle >
                                        {Translate.verification_details_confirmation_requests}
                                    </SubTitle>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography style={{textAlign:"center",marginTop:10,marginBottom:15}} className={this.classes.AnalyticsResult} >{loading ? <CircularProgress size={25}/> : verification_details}</Typography>
                                </Grid>
                            </Grid>
                        </Link>

                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg>
                        <Link to={'/manage/reviews'} className="todo_link">
                            <Grid container  style={{backgroundColor: "#fff",position:"relative"}} direction="row" alignItems="center" justify="center" className={clsx(this.classes.GridAsaPaperBaby,'grid-parent')}>
                                {
                                    reviews > 0 && <span className="ripple"></span>
                                }
                                <Grid item xs={11}>
                                    <SubTitle>
                                        {Translate.reviews_confirmation_requests}
                                    </SubTitle>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography style={{textAlign:"center",marginTop:10,marginBottom:15}} className={this.classes.AnalyticsResult} >{loading ? <CircularProgress size={25}/> : reviews}</Typography>
                                </Grid>
                            </Grid>
                        </Link>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg>
                        <Link to={'/manage/contacts'} className="todo_link">
                            <Grid container  style={{backgroundColor: "#fff",position:"relative"}} direction="row" alignItems="center" justify="center" className={clsx(this.classes.GridAsaPaperBaby,'grid-parent')}>
                                {
                                    contacts > 0 && <span className="ripple"></span>
                                }
                                <Grid item xs={11}>
                                    <SubTitle>
                                        {Translate.contacts}
                                    </SubTitle>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography style={{textAlign:"center",marginTop:10,marginBottom:15}} className={this.classes.AnalyticsResult} >{loading ? <CircularProgress size={25}/> : contacts}</Typography>
                                </Grid>
                            </Grid>
                        </Link>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg>
                        <Link to={'/manage/shops?marketer_mode=yes&page=0'} className="todo_link">
                            <Grid container  style={{backgroundColor: "#fff",position:"relative"}} direction="row" alignItems="center" justify="center" className={clsx(this.classes.GridAsaPaperBaby,'grid-parent')}>
                                {
                                    marketers > 0 && <span className="ripple"></span>
                                }
                                <Grid item xs={11}>
                                    <SubTitle>
                                        {Translate.pendingMarketer}
                                    </SubTitle>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography style={{textAlign:"center",marginTop:10,marginBottom:15}} className={this.classes.AnalyticsResult} >{loading ? <CircularProgress size={25}/> : marketers}</Typography>
                                </Grid>
                            </Grid>
                        </Link>
                    </Grid>
                </Grid>
                <Dialog open={open} onClose={() => this.setState({open:false})}>
                    <DialogContent>
                        <Typography>{Translate.activateSound}</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => this.setState({open:false})}
                            size="small"
                            color="primary"
                            variant="contained"
                        >
                            {Translate.activate}
                        </Button>
                    </DialogActions>
                </Dialog>
            </>

        );
    }
}

export default withStyles(Styles)(ToDos);